import React, { useContext } from "react";
import PageListerHelper from "./PageListerHelper";
import StandardPageListerPanel from "./StandardPageListerPanel";
import "./PageLister.css";
import { PagesManagementContext } from "../../routes/builderContexts";
import { AbstractTooltip as Tooltip } from "../ToolTip/ToolTip";

const PageLister = () => {
  const pagesManagementContext = useContext(PagesManagementContext);
  const { lessonPagesNumbering } = pagesManagementContext;
  const firstPages = pagesManagementContext.lessonPages.filter((_, i) => i <= 3);
  const content = pagesManagementContext.lessonPages
    .filter((_, i, a) => i >= 4 && i < a.length - 3)
    .map((el, i) => ({
      ...el,
      uniquePageListerID: i,
    }));

  const lastPages = pagesManagementContext.lessonPages.slice(-3);

  function returnCorrect(juice, pageToGoTo) {
    // Check if juice is already the full array (from updateName fix)
    // or if it's the filtered content array (from drag operations)
    const newPages =
      juice.length === pagesManagementContext.lessonPages.length
        ? juice.map((el, i) => ({ ...el, order: i })) // Already full array, just ensure order is correct
        : [...firstPages, ...juice, ...lastPages].map((el, i) => ({ ...el, order: i })); // Reconstruct from parts

    // changePageOrder now handles syncing with LessonPagesProvider internally
    pagesManagementContext.changePageOrder(newPages, pageToGoTo);
  }
  const switchPage = (i) => {
    pagesManagementContext.switchCurrentlyDisplayedPage(i);
  };

  return (
    <React.Fragment>
      {pagesManagementContext.lessonPages.length > 3 ? (
        <div className="pages-container" data-tooltip-id="Page List">
          <Tooltip id="Page List" />
          <div className="standard-side-panel-container">
            <StandardPageListerPanel pagePullout={pagesManagementContext.pagePullout} flagDirection={"title"} />

            {firstPages.map((el, i) => {
              const { currentAggregationOrder, currentlyDisplayedPageIndex } = pagesManagementContext;
              const isSelected = currentAggregationOrder === null && currentlyDisplayedPageIndex === i;

              return (
                <StandardPageListerPanel
                  key={el.name + i}
                  pagePullout={pagesManagementContext.pagePullout}
                  switchPage={switchPage}
                  flagDirection={"start"}
                  index={i}
                  name={el.name}
                  modes={el.lessonModeIds}
                  selected={isSelected}
                  displayedPageNumber={lessonPagesNumbering[i]}
                  reviewChanges={el.pageManifest.replacedAssets?.length > 0}
                />
              );
            })}

            <PageListerHelper
              key={content.map((el) => el.name).join(",")}
              lessonPages={content}
              updateArray={returnCorrect}
              contentNumbering={lessonPagesNumbering.slice(4, -3)}
            />
          </div>

          <div className="standard-side-panel-container">
            {lastPages.map((el, i) => {
              const { currentAggregationOrder, currentlyDisplayedPageIndex } = pagesManagementContext;
              const isSelected = currentAggregationOrder === null && currentlyDisplayedPageIndex === el.order;
              const fullLessonArrayPageIndex = pagesManagementContext.lessonPages.length - 3 + i;

              return (
                <StandardPageListerPanel
                  key={el.name + i}
                  pagePullout={pagesManagementContext.pagePullout}
                  switchPage={switchPage}
                  flagDirection={"end"}
                  index={fullLessonArrayPageIndex}
                  name={el.name}
                  modes={el.lessonModeIds}
                  selected={isSelected}
                  displayedPageNumber={lessonPagesNumbering[fullLessonArrayPageIndex]}
                  reviewChanges={el.pageManifest.replacedAssets?.length > 0}
                />
              );
            })}
          </div>
        </div>
      ) : (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      )}
    </React.Fragment>
  );
};
export default PageLister;
